const PRIVATE_ASSERTION_PREDICATE = 'https://ontology.origintrail.io/dkg/1.0#privateAssertionID';

module.exports = PRIVATE_ASSERTION_PREDICATE;
